var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94981 3.55878C5.41647 3.28935 5.41647 2.61578 4.9498 2.34635L1.0498 0.0946784C0.583137 -0.174752 -0.00019598 0.162036 -0.00019598 0.700897V5.20423C-0.00019598 5.74309 0.583138 6.07988 1.0498 5.81045L4.94981 3.55878Z",
    fill: "url(#paint0_linear_3124_6461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3124_6461",
    x1: 2.6498,
    y1: -0.000147,
    x2: 2.6498,
    y2: 5.90527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTriangle);
export default __webpack_public_path__ + "static/media/navTriangle.0478358236a2dea7696577f0652d9544.svg";
export { ForwardRef as ReactComponent };